export default "__VITE_ASSET__94e685a7__"